import View from "@components/View";
import "./NoAccess.css";
import ScalableWrapper from "@components/ScalableWrapper";
import MainMenuBackground from "@components/MainMenuBackground";
import { images, videos } from "@utils/media";
import Button from "@components/Button";
import { DiscordIcon } from "@components/Icons";
import { platform } from "@playroomkit/pr-common";

const NoAccess = () => (
  <View className="restricted-bg" enableEventCapturing>
    <MainMenuBackground source={videos.LoadingVideo}  placeholder={images.LoadingBackground} />
    <ScalableWrapper maintainAspectRatioBy="height">
      <View className="restricted-card relative">
        <img src="img/UI/Ticket_BG.webp" alt="ticket" />
        <View className="restricted-message">
          <h2>HEY HUMAN!</h2>
          <h2 className="restricted-description">
            LAST SHOW IS AN EXCLUSIVE EXPERIENCE FOR A CHOSEN FEW. AND LOOKS
            LIKE YOU DON’T HAVE THE TICKET.
          </h2>
          <a
            href="https://www.discord.gg/thelastshow"
            target="_blank"
            rel="noreferrer"
            className="absolute -bottom-5"
          >
            <Button className="font-[Slackey] skew-x-6 px-8 py-1 text-white bg-[#005BCD] flex items-center gap-2 text-2xl border-4 border-black border-solid rounded-lg outline-4 outline-[#1F1B98] outline hover:bg-[#004CAD] transition">
              <DiscordIcon />
              Get Ticket
            </Button>
          </a>
        </View>
        {!platform.isRunningInDiscord && (
          <a
            href={`${
              import.meta.env.VITE_PLAYROOM_BASE_URL
            }/auth/discord/login?gameId=${import.meta.env.VITE_GAME_ID}`}
            className="pointer-events-auto absolute bottom-8 underline decoration-4 text-xl underline-offset-8"
          >
            Already got ticket? Login with Discord
          </a>
        )}
      </View>
    </ScalableWrapper>
  </View>
);

export default NoAccess;
